import "angular";
import PaeFactory from "./PaeFactory";
import PaeService from "./PaeService";

const moduleName = "PaeModule";
const PaeModule = angular
    .module(moduleName, [])
    .service("paeService", PaeService)
    .factory("paeFactory", PaeFactory);

export default PaeModule;
